import { BaseDto } from './base.dto';
import { BrandDto } from './brand.dto';
import { MenuCategoryHoursDto } from './menuCategoryHours.dto';
import { MenuCategoryItemDto } from './menuCategoryItem.dto';

export class MenuCategoryDto extends BaseDto {
  id: number;
  menuId: number;
  photoURL: string;
  name: string;
  startDate: Date;
  endDate: Date;
  enabled?: boolean;
  description?: string;
  menuCategoryItems: MenuCategoryItemDto[];
  merchantId: number;
  sharedSourceName?: string;
  brandId?: number;
  brand?: BrandDto;
  tag: string;
  colorCode: string;
  menuCategoryHours?: MenuCategoryHoursDto[];
  active?: boolean;
}
